export enum PaymentMethod {
  Cash = 'Cash',
  Card = 'Card',
  BankTransfer = 'BankTransfer',
  OnlineWallet = 'OnlineWallet',
  Mixed = 'Mixed',
}

export enum SellStage {
  Received = 'Received',
  Preparing = 'Preparing',
  Verification = 'Verification',
  Checkout = 'Checkout',
  ReadyForDelivery = 'ReadyForDelivery',
  Delivered = 'Delivered',
  Cancelled = 'Cancelled',
}
